import { pageGroupKey } from '~/st-doc-viewer/page-groups/page-group-key'
import type { PageGroup, PageGroupType } from '@st/sdk'
import type { DocumentViewerMessage } from '@st/document-viewer-kit'
import { useProcess, useSelect } from '~/store'
import { PageGroupList } from '~/st-doc-viewer/page-groups/page-group-list'
import { CutIcon } from '~/st-doc-viewer/page-groups/page-group-divider'
import { DeliveryPageGroupMenu } from './page-group-menu'

export function DeliveryPageGroups({
  groups,
  groupTypes,
  sendViewerMessage
}: {
  groups: PageGroup[]
  groupTypes: PageGroupType[]
  sendViewerMessage: (message: DocumentViewerMessage) => void
}) {
  const folder = useProcess('stFolder')
  const archived = useSelect(
    'stFolder',
    (state) => state.status === 'ready' && state.folderState.folder.archived === true
  )
  const edit = useSelect('stFolder', (state) => {
    if (state.status !== 'ready') throw new Error('Page groups require a ready folder')
    const editor = state.taxReturnDelivery.editor
    if (editor.type != 'bookmarks') throw new Error('Page groups require Bookmarks')
    return editor.edit
  })
  return (
    <fieldset disabled={archived} className="min-w-0">
      <p className="p-3 text-xs leading-relaxed text-stone-500">
        Use{' '}
        <span role="img" aria-label="scissors">
          <CutIcon className="inline-block size-3.5 align-[-2px]" />
        </span>{' '}
        between pages to split or combine.
      </p>
      <PageGroupList
        groups={groups}
        sendViewerMessage={sendViewerMessage}
        renderGroup={(group) => {
          const editing = edit.status === 'editing' && edit.key === pageGroupKey(group)
          const onEdit = () =>
            folder.send({
              type: 'taxReturnDelivery',
              message: { type: 'pageGroup', message: { type: 'pageGroupOpened', group } }
            })
          return {
            editing,
            onEdit,
            renderEditor: () => {
              if (edit.status !== 'editing') throw new Error('Editor must have an open draft')
              return <DeliveryPageGroupMenu group={edit.group} groupTypes={groupTypes} />
            }
          }
        }}
      />
    </fieldset>
  )
}
